import runStrategies from 'Utils/run-strategies';
import strategies from './breadcrumbs/index';

export default (options = {}) => runStrategies(strategies)(options);
